import apiCarga from "@/services/vex/apiCarga";

async function iniciarVistoria(placa) {
    let token = JSON.parse(localStorage.getItem("enterprise")).name;
    const uri = `/empresa/${token}/iniciarvistoria/${placa}/json`;

    try {
        const response = await apiCarga.get(uri);

        const ERR = response.data?.status === "ERR" || response.status !== 200;
        
        if (!ERR) {
            return response.data;
        } else {
            throw new Error(response.data?.message ?? "Erro ao requisitar dados para iniciar vistoria");
        }
    } catch (error) {
        if(error.response?.data?.message) {
            error.message = error.response?.data?.message;
        }
        throw error;
    }
}

export default iniciarVistoria;
